<div class="wrapper">
  <div class="container py-4 survey-container">

    <!-- FORM VIEW -->
    <div *ngIf="viewState === 'form'">
      <h1 class="survey-title" [ngClass]="{'text-right': isRtl, 'text-left': !isRtl}">{{surveyTitle}}</h1>

      <div class="alert alert-danger" [ngClass]="{'text-right': isRtl, 'text-left': !isRtl}" *ngIf="showValidationError">
        {{'afterVisitSurvey.validationError'|translate}}
      </div>

      <div class="survey-question" *ngFor="let q of questions; let i = index">
        <div class="question-label" [ngClass]="{'text-right': isRtl, 'text-left': !isRtl}">{{'afterVisitSurvey.questionPrefix'|translate}}{{i + 1}}</div>
        <div class="question-text" [ngClass]="{'text-right': isRtl, 'text-left': !isRtl}">
          {{q.textKey|translate}} <span class="text-danger" *ngIf="q.required">*</span>
        </div>

        <!-- RATING -->
        <div *ngIf="q.type === 'rating'" class="star-rating" [ngClass]="{'justify-content-end': isRtl}">
          <i *ngFor="let val of ratingValues"
             class="fa-star star-icon"
             [ngClass]="answers[q.id] >= val ? 'fas filled' : 'far'"
             (click)="setRating(q.id, val)"></i>
        </div>

        <!-- YES/NO -->
        <div *ngIf="q.type === 'yesno'" class="d-flex" style="gap: 12px;">
          <button type="button" class="btn flex-option"
                  [ngClass]="answers[q.id] === 'Yes' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setAnswer(q.id, 'Yes')">{{'button.yes'|translate}}</button>
          <button type="button" class="btn flex-option"
                  [ngClass]="answers[q.id] === 'No' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setAnswer(q.id, 'No')">{{'button.no'|translate}}</button>
          <button type="button" class="btn flex-option" *ngIf="q.includeNA"
                  [ngClass]="answers[q.id] === 'N/A' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setAnswer(q.id, 'N/A')">{{'button.na'|translate}}</button>
        </div>

        <!-- CHOICE -->
        <div *ngIf="q.type === 'choice'">
          <div class="form-check mb-2" [ngClass]="{'form-check-rtl': isRtl}" *ngFor="let opt of q.options">
            <input class="form-check-input" type="radio" [name]="q.id" [id]="q.id + '_' + opt.value"
                   [checked]="answers[q.id] === opt.value" (change)="setAnswer(q.id, opt.value)">
            <label class="form-check-label" [ngClass]="{'text-right': isRtl, 'text-left': !isRtl}" [for]="q.id + '_' + opt.value">{{opt.labelKey|translate}}</label>
          </div>
        </div>

        <!-- TEXT -->
        <div *ngIf="q.type === 'text'">
          <textarea class="form-control question-textarea" [ngClass]="{'text-right': isRtl, 'text-left': !isRtl}" rows="3"
                    maxlength="8000"
                    [ngModel]="answers[q.id]" (ngModelChange)="setAnswer(q.id, $event)"
                    placeholder="{{'afterVisitSurvey.textPlaceholder'|translate}}"></textarea>
        </div>
      </div>
    </div>

    <!-- THANK YOU VIEW -->
    <div *ngIf="viewState === 'thankyou'" class="text-center py-5">
      <div class="mb-4">
        <i class="fa fa-check-circle text-success" style="font-size: 64px;"></i>
      </div>
      <h4 class="fw-bold text-info mb-2">{{'afterVisitSurvey.thankYouTitle'|translate}}</h4>
      <p class="text-muted px-3" [ngClass]="{'text-right': isRtl}">
        {{'afterVisitSurvey.thankYouBody'|translate}}
      </p>
    </div>

  </div>
</div>

<footer class="p-3" *ngIf="viewState === 'form'">
  <div class="container survey-container">
    <button type="button" class="btn btn-primary w-100" (click)="submitSurvey()">
      {{'afterVisitSurvey.submit'|translate}}
    </button>
  </div>
</footer>
